import { SortingQuery } from 'types/sortingQuery';

export const encodeSortQuery = <T extends string>({
  prop,
  order,
}: SortingQuery<T>) => `${prop},${order}`;
